import React from 'react';
import {Switch} from 'react-router-dom';
import {C800CallLogs} from "../800CallLogs";
import {AirQualityMonitoring} from "../AirQualityMonitoring";
import {useAuth} from "../Auth";
import {ContentRoute} from "../ContentRoute";
import {TabsRoute} from "../TabsRoute";
import {TabItem} from "../TabsRoute/types";
import TSMMonitoring from "../TSMMonitoring";
import TSMTopFive from "../TSMTopFive";
import TSMAll from "../TSMAll";
import {_800callLogs, airQualityMonitoring, tracksideMonitoring,calibrations,tsmTopFive,tsmAll} from "./urls";
import {Calibrations} from "../Calibrations";
//import Callback from "../Auth/Callback";

const tabOptions: TabItem[] = [{
  label: "PM10",
  value: "PM10",
}, {
    label: "Calibrations",
    value: "Calibrations",
}]

export const Routes: React.FC = ({children}) => {
    const {userRole} = useAuth();
    return (
      <React.Fragment>
        <Switch>

          <ContentRoute path={_800callLogs} exact component={C800CallLogs}/>
	  <ContentRoute path={tracksideMonitoring} exact component={TSMMonitoring}/>
	  <ContentRoute path={tsmTopFive} exact component={TSMTopFive}/>
	  <ContentRoute path={tsmAll} exact component={TSMAll}/>
          {userRole !== "user" && <TabsRoute
				    options={tabOptions}
				    path={calibrations}
				    exact
				    component={Calibrations}
				  />}
          {userRole !== "user" &&
           <TabsRoute
             options={tabOptions}
             path={airQualityMonitoring}
             exact
             component={AirQualityMonitoring}
           />
          }
          {/** Default routes depending on the userRole **/}
          {userRole !== "user" ? (
            <TabsRoute
              options={tabOptions}
              component={AirQualityMonitoring}
            />
          ) : null /** (
                      <ContentRoute
                      component={C800CallLogs}
                      /> 
                      )**/ } 
        </Switch>
        {children}
      </React.Fragment>
    );
};
